import React from 'react';
import { Helmet } from 'react-helmet';

function Help_Seo() {
    return (
        <div>
            <Helmet>
                <title>Need help? We are here to support you at every step | Ifepay</title>
                <meta name="description" content="We have created knowledge base to support your queries. Please feel free to contact us if you need any further information." />
                <meta property="og:title" content="Need help? We are here to support you at every step | Ifepay" />
                <meta property="og:description" content="We have created knowledge base to support your queries. Please feel free to contact us if you need any further information." />
                <meta property="og:image" content="https://ifepay.co.uk/assets/images/logo.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://ifepay.co.uk/help"/>
            </Helmet>
        </div>
    )
}

export default Help_Seo
